// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AX2H","colBig":"styles_colBig__3-5hS","colSmall":"styles_colSmall__3mfC7"};